import {FC, ReactNode} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {WithChildren} from '_metronic/helpers'
import {checkIsActive} from 'utility/checkvalidUrl'

type Props = {
  to: string
  title: string
  fontIcon?: string
  /** A non-Bootstrap icon (a React element), for the few items that have no bi-* equivalent. */
  custIcon?: ReactNode
  /** Overrides the url match, when the menu decides which of several matching items is current. */
  isActive?: boolean
  hasBullet?: boolean
}

// stock gates in SidebarMenuMain (feature.code === route_code), so items carry no gate of their own.
const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  fontIcon,
  custIcon,
  isActive,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  return (
    <div className='menu-item'>
      <Link
        className={clsx('menu-link without-sub', {active: isActive ?? checkIsActive(pathname, to)})}
        to={to}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}
        {!fontIcon && custIcon && <span className='menu-icon'>{custIcon}</span>}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
